import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const faqs = [
  {
    q: "Que es un 'Episodio de Atencion'?",
    a: "Un episodio de atencion agrupa todas las citas, notas clinicas, ejercicios y mediciones de progreso relacionadas con un mismo motivo de consulta del paciente. En lugar de ver citas aisladas, usted ve el cuadro completo de la recuperacion.",
  },
  {
    q: "Como accede mi paciente al portal?",
    a: "Su paciente recibe un enlace seguro (magic link) por email. No necesita descargar ninguna app ni crear contraseña. Con un clic accede a sus ejercicios, citas y puede reportar su progreso.",
  },
  {
    q: "Puedo migrar mis datos actuales?",
    a: "Si. Ofrecemos soporte para migrar su base de pacientes desde Excel o CSV. Los datos clinicos historicos se pueden adjuntar como documentos al expediente de cada paciente.",
  },
  {
    q: "Es seguro para datos clinicos?",
    a: "Si. Todos los datos se transmiten cifrados (HTTPS/TLS), se almacenan con cifrado en reposo, y cada clinica tiene sus datos completamente aislados (multi-tenant). Cumplimos con las mejores practicas de seguridad para datos de salud.",
  },
  {
    q: "Cuanto dura la prueba gratis?",
    a: "La prueba gratis dura 14 dias con acceso completo a todas las funcionalidades. No necesita tarjeta de credito para empezar. Al terminar, puede elegir el plan que mejor se adapte a su practica.",
  },
  {
    q: "Funciona en mi telefono?",
    a: "Si. La plataforma del fisioterapeuta esta optimizada para desktop y tablet. El portal del paciente esta disenado mobile-first para que sus pacientes lo usen comodamente desde su celular.",
  },
];

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-sm font-semibold text-emerald-600 uppercase tracking-widest mb-3">
            FAQ
          </p>
          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-slate-900 tracking-tight mb-4">
            Preguntas frecuentes
          </h2>
        </div>

        {/* Accordion */}
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border border-slate-100 rounded-xl px-6 data-[state=open]:border-emerald-200 data-[state=open]:bg-emerald-50/30 transition-colors duration-200"
            >
              <AccordionTrigger className="text-left font-heading font-semibold text-base text-slate-800 hover:text-emerald-600 py-5 hover:no-underline">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-slate-500 leading-relaxed pb-5">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
